// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._2rko19bv{border-radius:10px}._154i1b66{top:var(--ds-space-050,4px)}
._154iidpf{top:0}
._1bsb1osq{width:100%}
._1bsbwk75{width:var(--_ys364u)}
._1ltv1b66{left:var(--ds-space-050,4px)}
._1ltvidpf{left:0}
._4t3i1osq{height:100%}
._4t3iwk75{height:var(--_ys364u)}
._kdam118y{filter:var(--_y27h52)}
._kqswstnw{position:absolute}
._t9ec161g{transform:translate3d(0,0,0)}
._w6ng15vq{backface-visibility:hidden}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/node_modules/@atlaskit/smart-card/dist/esm/view/common/ai-prism/ai-glowing-border/animated-svg-container.compiled.css"],"names":[],"mappings":";AACA,WAAW,kBAAkB,CAAC,WAAW,2BAA2B;AACpE,WAAW,KAAK;AAChB,WAAW,UAAU;AACrB,WAAW,oBAAoB;AAC/B,WAAW,4BAA4B;AACvC,WAAW,MAAM;AACjB,WAAW,WAAW;AACtB,WAAW,qBAAqB;AAChC,WAAW,qBAAqB;AAChC,WAAW,iBAAiB;AAC5B,WAAW,4BAA4B;AACvC,WAAW,0BAA0B","sourcesContent":["\n._2rko19bv{border-radius:10px}._154i1b66{top:var(--ds-space-050,4px)}\n._154iidpf{top:0}\n._1bsb1osq{width:100%}\n._1bsbwk75{width:var(--_ys364u)}\n._1ltv1b66{left:var(--ds-space-050,4px)}\n._1ltvidpf{left:0}\n._4t3i1osq{height:100%}\n._4t3iwk75{height:var(--_ys364u)}\n._kdam118y{filter:var(--_y27h52)}\n._kqswstnw{position:absolute}\n._t9ec161g{transform:translate3d(0,0,0)}\n._w6ng15vq{backface-visibility:hidden}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
